import React from "react";
import { MoreHorizontal, Pencil, ExternalLink, UserCog, Trash2, RotateCcw, ShieldX, Tag } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuSub, DropdownMenuSubContent, DropdownMenuSubTrigger, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";

export default function RowActions({ row, viewUrl, transitions, isUsers, onEdit, onActAs, onStatus, onDelete, onRestore, onHardDelete }) {
  const id = row.id;
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button onClick={(e) => e.stopPropagation()} className="rounded-full p-2 text-slate-500 hover:bg-slate-100 hover:text-[#071b22] transition-colors" aria-label="Row actions" data-testid={`crud-actions-${id}`}>
          <MoreHorizontal className="h-4 w-4" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-52 rounded-xl" onClick={(e) => e.stopPropagation()}>
        <DropdownMenuItem onClick={onEdit} data-testid={`crud-edit-${id}`}><Pencil className="h-4 w-4 mr-2" /> Edit</DropdownMenuItem>
        {viewUrl && <DropdownMenuItem onClick={() => window.open(viewUrl, "_blank")} data-testid={`crud-view-${id}`}><ExternalLink className="h-4 w-4 mr-2" /> View live</DropdownMenuItem>}
        {isUsers && !row.deleted_at && <DropdownMenuItem onClick={onActAs} data-testid={`crud-actas-${id}`}><UserCog className="h-4 w-4 mr-2" /> Act as user</DropdownMenuItem>}
        {transitions?.length > 0 && (
          <DropdownMenuSub>
            <DropdownMenuSubTrigger data-testid={`crud-status-${id}`}><Tag className="h-4 w-4 mr-2" /> Change status</DropdownMenuSubTrigger>
            <DropdownMenuSubContent className="rounded-xl">
              <DropdownMenuLabel className="text-xs">Move to…</DropdownMenuLabel>
              {transitions.map((s) => <DropdownMenuItem key={s} onClick={() => onStatus(s)} className="capitalize" data-testid={`crud-status-${id}-${s}`}>{s.replace(/_/g, " ")}</DropdownMenuItem>)}
            </DropdownMenuSubContent>
          </DropdownMenuSub>
        )}
        <DropdownMenuSeparator />
        {row.deleted_at
          ? <DropdownMenuItem onClick={onRestore} className="text-emerald-700" data-testid={`crud-restore-${id}`}><RotateCcw className="h-4 w-4 mr-2" /> Restore</DropdownMenuItem>
          : <DropdownMenuItem onClick={onDelete} className="text-rose-600" data-testid={`crud-delete-${id}`}><Trash2 className="h-4 w-4 mr-2" /> Move to trash</DropdownMenuItem>}
        <DropdownMenuItem onClick={onHardDelete} className="text-slate-500" data-testid={`crud-hard-${id}`}><ShieldX className="h-4 w-4 mr-2" /> Delete permanently</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
